import React, {useMemo} from "react";
function DataGridTooltip(props) {
    const data = useMemo(()=> (props.api.getDisplayedRowAtIndex(props.rowIndex).data), [])
    return (
        <div className="data-grid-tooltip">
            <p><span>{data.fdrnotes}</span></p>
        </div>
    );
}
export default DataGridTooltip;